import { render, staticRenderFns } from "./SelectCards.vue?vue&type=template&id=24e77278&scoped=true&lang=pug&"
import script from "./SelectCards.vue?vue&type=script&lang=js&"
export * from "./SelectCards.vue?vue&type=script&lang=js&"
import style0 from "./SelectCards.vue?vue&type=style&index=0&id=24e77278&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e77278",
  null
  
)

export default component.exports